import { Component, OnInit, Input, Output, EventEmitter, HostListener, ElementRef, ViewChild } from '@angular/core';
import { Modal } from '@app/model/modal';
import { Sites } from '@app/model/sites';

import { UsersService } from '@app/services/users.service';
import { BaseComponent } from '@app/directives/base-component';
import * as _ from 'lodash-es';

@Component({
    selector: 'dealer-site-arm-schedule',
    templateUrl: './site-arm-schedule.component.html',
    styleUrls: ['../../common.scss', './site-arm-schedule.component.scss'],
    standalone: false
})
export class SiteArmScheduleComponent extends BaseComponent implements OnInit {
  @Input() active: boolean;
  @Input() modal: Modal;
  @Input() site: Sites;
  @Output() onClose: EventEmitter<any> = new EventEmitter();
  @Output() onUpdate: EventEmitter<any> = new EventEmitter();
  @ViewChild('selectuser') selectuser: ElementRef;

  m_warning = new Modal();

  enable_modal = false;
  isEditMode = false;
  isLoading = false;

  _schedule: any = {};
  newSchedule: any = {};

  armingConditions = [{value:1, name:'Site to Arm'}, {value:2, name:'Site to Disarm'}];
  selArmingCondition = this.armingConditions[0];

  hours = Array.from({length: 24}, (_, i) => i<10 ? '0'+i : i+'');
  minutes = Array.from({length: 60}, (_, i) => i<10 ? '0'+i : i+'');
  selHour = this.hours[0];
  selMinutes = this.minutes[0];
  selDaysOfWeek = []; // 0~7 sunday~saturday
  isDisable = false;

  constructor(
    private usersService: UsersService,
  ) { super(); }

  ngOnInit() {
    // User data loaded by APP_INITIALIZER - no getMe() usage in this component
    console.log('minutes', this.minutes);
  }

  ngOnChanges(changes) {
    if (changes['active'] && this.active) {
      this.enable_modal = true;
      this.initData();
      
      if (this.modal.data['schedule']) {
        this.isEditMode = true;
        this.setData();
      } else {
        this.isEditMode = false;
      }
    }
  }

  @HostListener('document:mousedown', ['$event'])
  onGlobalClick(event): void {
    if (!this.selectuser) return;
    if (!this.selectuser.nativeElement.contains(event.target)) {
    }
  }

  close(res= false) {
    let data = {}
    if(res) {
      data = {
        target: this.isEditMode ? 'edit' : 'add',
        selArmingCondition : this.selArmingCondition,
        selHour : this.selHour,
        selMinutes : this.selMinutes,
        selDaysOfWeek : this.selDaysOfWeek,
        _schedule : this._schedule,
      }
    } else {
      data = { target: null }
    }
    this.onClose.next(data);
    this.modal.close();

    setTimeout(_ => {
      this.enable_modal = false;
    }, 200);
  }

  doUpdate() {
    this.onUpdate.next(true);
  }

  doAction() {
    this.close(true)
  }

  initData(){
    this._schedule = {};
    this.selHour = this.hours[0];
    this.selMinutes = this.minutes[0];
    this.selDaysOfWeek = []; // 0~7 sunday~saturday
    this.selArmingCondition = this.armingConditions[0];
    this.isDisable = false;
  }

  setData() {
    this._schedule = _.cloneDeep(this.modal.data['schedule']);
    this.newSchedule = _.cloneDeep(this._schedule);
    this.selArmingCondition = this.armingConditions.find(armingCondition => armingCondition.value === this._schedule.type);
    const [hour, minute, second] = this._schedule.start_time.split(':');
    this.selHour = hour;
    this.selMinutes = minute;
    this.selDaysOfWeek = [this._schedule.day_of_week];
    this.isDisable = true;
    console.log('hour, minute, second', hour, minute, second)
  }

  setDayOfWeek(dayIdx) {
    const idx = this.selDaysOfWeek.indexOf(dayIdx);
    if (idx !== -1) {
      this.selDaysOfWeek.splice(idx, 1);
    } else {
      this.selDaysOfWeek.push(dayIdx);
    }
    this.selDaysOfWeek = this.selDaysOfWeek.sort();
  }
}
